import React, { useRef } from "react";
import { IFlowInputDataEditorState } from "../FlowInputManagement/FlowInputDataEditor";
import { FlowInputManagementController } from "../FlowInputManagement";
import { IBannerContext } from "@plex/react-components";
import { IUserDefinedSchemasEditorState } from "../UserDefinedSchemaManagement/UserDefinedSchemasEditor";
import { IUserDefinedSchemaDetailsDialogState } from "../UserDefinedSchemaManagement/UserDefinedSchemaDetailsDialog";
import { IUserDefinedSchemaPropertyDetailsDialogState } from "../UserDefinedSchemaManagement/UserDefinedSchemaPropertyDetailsDialog";
import { IUserDefinedSchemasAddDialogPropsState } from "../UserDefinedSchemaManagement/UserDefinedSchemasAddDialog";
import { IUserDefinedSchemaPropertyAddDialogPropsState } from "../UserDefinedSchemaManagement/UserDefinedSchemaPropertyAddDialog";

const UNASSIGNED: any | null = {};

export const ViewControllerContext = React.createContext<IViewController | any>(undefined);

export interface IViewController {
  experimentalModeState: boolean;
  flowInputController: FlowInputManagementController;
  flowInputDataEditorState: IFlowInputDataEditorState;
  setFlowInputDataEditorState: React.Dispatch<React.SetStateAction<IFlowInputDataEditorState>>;
  userDefinedSchemasEditorState: IUserDefinedSchemasEditorState;
  setUserDefinedSchemasEditorState: React.Dispatch<React.SetStateAction<IUserDefinedSchemasEditorState>>;
  userDefinedSchemaDetailsDialogState: IUserDefinedSchemaDetailsDialogState;
  setUserDefinedSchemaDetailsDialogState: React.Dispatch<React.SetStateAction<IUserDefinedSchemaDetailsDialogState>>;
  userDefinedSchemaPropertyDetailsDialogState: IUserDefinedSchemaPropertyDetailsDialogState;
  setUserDefinedSchemaPropertyDetailsDialogState: React.Dispatch<
    React.SetStateAction<IUserDefinedSchemaPropertyDetailsDialogState>
  >;
  userDefinedSchemasAddDialogState: IUserDefinedSchemasAddDialogPropsState;
  setUserDefinedSchemasAddDialogState: React.Dispatch<React.SetStateAction<IUserDefinedSchemasAddDialogPropsState>>;
  userDefinedSchemaPropertyAddDialogState: IUserDefinedSchemaPropertyAddDialogPropsState;
  setUserDefinedSchemaPropertyAddDialogState: React.Dispatch<
    React.SetStateAction<IUserDefinedSchemaPropertyAddDialogPropsState>
  >;
  bannerContext: IBannerContext;
}

export const useViewController = (): IViewController | any => {
  return React.useContext(ViewControllerContext);
};

export const useSingleton = (factory: any) => {
  const sharedDataRef = useRef(UNASSIGNED);

  if (sharedDataRef.current == UNASSIGNED) {
    sharedDataRef.current = factory();
  }

  return sharedDataRef.current;
};
